<template>
<m-pageframe
    title="{organization-label}: Phone Validation Details"
>
<v-container
    fluid
    style="padding-left: 15px; padding-right: 15px"
>

    <v-text-field
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
        autocomplete="off"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickRefresh()"
                >
                    <v-list-item-title>Refresh...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickStartValidation()"
                >
                    <v-list-item-title>Validate Phone Numbers...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickExport()"
                >
                    <v-list-item-title>Export to Excel...</v-list-item-title>
                </v-list-item>

                
            </v-list>
        </v-menu> 
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.date="{ item }">
            {{$rc.pretty(item.time_created, 'date')}}
        </template>

         <template v-slot:item.time="{ item }">
            {{$rc.pretty(item.time_created, 'time')}}
        </template>

        <template v-slot:item.endpoint="{ item }">
            {{$rc.pretty(item.endpoint, 'endpoint')}}
        </template>

         <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickDetails(item)"
                >
                    <v-list-item-title>Technical Details...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

    <m-technical-details-dialog
        ref="tech-details"
        title="Validation Technical Details"
    />

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    
    data() {
        return {
            full_text: null,
            results: [],

            headers: [
                { text: 'Date', value: 'date'},
                { text: 'Time', value: 'time'},
                { text: 'Phone Number', value: 'endpoint'},
                { text: 'State', value: 'state'},
                { text: 'Line Type', value: 'line_type'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

    mounted () {
        this.doUpdate();

        
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest(
                'LIST: /api/v1/validation/endpoint',
            
                {
                    'organization_id' : this.$route.params.organization_id,
                    'full_text': this.full_text,
                },
            
                (data) => {
                   this.results = data.results;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to list phone validation details.');
                },
            );
        },

        onClickDetails(item)
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'PUT: /api/v1/validation/endpoint/get-bandwidth-details',
            
                {
                    'validation_batch_id' : item.validation_batch_id,
                    'endpoint' : item.endpoint,  
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.$refs['tech-details'].showDialog(data);
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to get validation details');
                },
            );
        },

        onClickStartValidation()
        {
            this.$rc.prompt({
                'title' : 'Phone Numbers to Validate',
                'label' : 'Phone numbers to validate',
                'value' : null,
                'textarea' : true,
                'after_prompt' : (value) => {
                    
                    this.$rc.showSpinner();
                    
                    this.$rc.rest(
                        'PUT: /api/v1/validation/endpoint/start-validation',
                    
                        {
                            'endpoints_as_text' : value,
                            'organization_id' : this.$route.params.organization_id,
                        },
                    
                        (data) => {
                            this.$rc.hideSpinner();

                            this.doUpdate();
                        },
                    
                        () => {
                            this.$rc.hideSpinner();
                            this.$rc.alert('Error','Unable to complete API call');
                        },
                    );
                }
            });
        },

        onClickRefresh()
        {
            this.doUpdate();
        },

        onClickExport()
        {
            this.$rc.excelExport(
                    'EXPORT: /api/v1/validation/endpoint/export-validation-details/:organization_id',
                    {
                        'organization_id' : this.$route.params.organization_id,
                    }
                );
        },
        
    },
    
}
</script>

<style lang="scss" scoped>
</style>